import { assertEnv } from "../lib";
import { Beacon } from "../types";

const REACT_APP_API_BASE_URL = assertEnv("REACT_APP_API_BASE_URL");

/**
 * Fetch all beacons from the API
 */
export async function getAllBeacons(): Promise<Beacon[]> {
  const apiUrl = `${REACT_APP_API_BASE_URL}/beacons`;

  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`API error: ${response.status} - ${await response.text()}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching beacons:', error);
    throw error;
  }
}

/**
 * Fetch a specific beacon by ID
 */
export async function getBeacon(beaconId: string): Promise<Beacon | undefined> {
  const apiUrl = `${REACT_APP_API_BASE_URL}/beacons/${beaconId}`;

  try {
    const response = await fetch(apiUrl);

    if (!response.ok) {
      throw new Error(`API error: ${response.status} - ${await response.text()}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching beacon ${beaconId}:`, error);
    return undefined;
  }
}

/**
 * Save or update a beacon
 */
export async function setBeacon(beacon: Beacon) {
  const apiUrl = `${REACT_APP_API_BASE_URL}/beacons/${beacon.beaconId}/set`;
  const body = {
    h3Tile: beacon.h3Tile,
    sdp: beacon.metadata.sdp
  };

  console.log('Saving beacon:', beacon);

  try {
    // Make the API call
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    return response;
  } catch (error) {
    console.error('Error saving beacon:', error);
    throw error;
  }
}
